import { render, staticRenderFns } from "./OptinOnboardingModal.vue?vue&type=template&id=6d3b93de&scoped=true&"
import script from "./OptinOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./OptinOnboardingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b93de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3b93de')) {
      api.createRecord('6d3b93de', component.options)
    } else {
      api.reload('6d3b93de', component.options)
    }
    module.hot.accept("./OptinOnboardingModal.vue?vue&type=template&id=6d3b93de&scoped=true&", function () {
      api.rerender('6d3b93de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/OptinOnboardingModal.vue"
export default component.exports